import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
`;

export const HeaderBase = styled.div`
	padding-left: 12px;
	padding-right: 10px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: transparent;
	padding-top: 18px;
	padding-bottom: 12px;
`;

export const ElementName = styled.div`
	font-size: 16px;
	font-family: 'Inter', sans-serif;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const DsComponentName = styled.div`
	font-size: 13px;
	font-family: 'JetBrains Mono', monospace;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	margin-top: 8px;
`;
